export default __webpack_public_path__ + "static/media/logo-gradient.787d3de9.png";